import { MetadataRunConditionDto } from '@/Domain/api/Shared/dto/MetadataRunCondition.dto';
import {
  metadataConditionUsesValue,
  metadataConditionValuesSchema,
} from '@/Domain/helper/metadataRunCondition.helper';

export const ALERT_RUN_CONDITIONS_MAX_COUNT = 10;

export const alertRunConditionUsesValue = metadataConditionUsesValue;

export const isAlertRunConditionComplete = (condition: MetadataRunConditionDto): boolean => {
  if (!condition.metadata_key.trim()) return false;
  if (condition.operator === 'is_one_of') {
    return (
      !!condition.values?.length &&
      metadataConditionValuesSchema().safeParse(condition.values).success
    );
  }
  if (!alertRunConditionUsesValue(condition.operator)) return true;
  return condition.value !== null && condition.value.length > 0;
};

export const areAlertRunConditionsComplete = (conditions: MetadataRunConditionDto[]): boolean =>
  conditions.every(isAlertRunConditionComplete);
